import { atom, useAtom } from 'jotai';

export interface SystemCurrencyConfig {
  code: string;
  symbol: string;
  locale?: string;
  name?: string;
}

interface SystemStates {
  isLoading: boolean;
  currency: SystemCurrencyConfig;
}

export const systemFixedCurrency: SystemCurrencyConfig = {
  code: 'EUR',
  symbol: '€',
  locale: 'fr-FR',
  name: 'Euro',
};

const initialState = atom<SystemStates>({
  isLoading: false,
  currency: systemFixedCurrency,
});

export const useSystemStore = () => {
  const [systemStates, setState] = useAtom<SystemStates>(initialState);

  const dynamicSetState = (params: Partial<SystemStates>) => {
    setState((prev: SystemStates) => ({
      ...prev,
      ...params,
    }));
  };

  const setSySLoading = (isLoading: boolean) => {
    dynamicSetState({ isLoading });
  };

  const fakeSystemLoading = (delay?: 3000) => {
    dynamicSetState({ isLoading: true });
    setTimeout(() => {
      dynamicSetState({ isLoading: false });
    }, delay);
  };

  return {
    systemStates,
    setSySLoading,
    fakeSystemLoading,
  };
};
